import { getSectionFromUrl } from "../utils/general"

const getSessionStorageIfAvailable = (name) => {
  if (typeof window !== `undefined` && !!sessionStorage.getItem(name)) {
    // delay to make sure clearSessionStorage has had a change to run
    setTimeout(() => {
      return sessionStorage.getItem(name)
    }, 250)
  }
  return null
}

const getSessionStorageObjectIfAvailable = (name) => {
  if (typeof window !== `undefined` && !!sessionStorage.getItem(name)) {
    setTimeout(() => {
      let objectString = sessionStorage.getItem(name)
      return JSON.parse(objectString)
    }, 250)
  }
  return null
}

const defaultState = {
  quizProgress: !!getSessionStorageIfAvailable("quizProgress")
    ? parseInt(getSessionStorageIfAvailable("quizProgress"))
    : 0,
  get progressBarProgress() {
    return !!this.quizProgress ? this.quizProgress : 0
  },
  sectionLength: !!getSessionStorageIfAvailable("sectionLength")
    ? parseInt(getSessionStorageIfAvailable("sectionLength"))
    : 0,
  currentSection: !!getSessionStorageIfAvailable("currentSection")
    ? getSessionStorageIfAvailable("currentSection")
    : getSectionFromUrl(),
  age: !!getSessionStorageIfAvailable("userAge")
    ? parseInt(getSessionStorageIfAvailable("userAge"))
    : 0,
  endQuizEarly: false,
  interstitial: false,
  token: !!getSessionStorageIfAvailable("userToken")
    ? getSessionStorageIfAvailable("userToken")
    : "",
  currentQuestionId: "",
  responseComplete: false,
  resultsResponseComplete: false,
  totalQuestions: !!getSessionStorageIfAvailable("totalQuestions")
    ? parseInt(getSessionStorageIfAvailable("totalQuestions"))
    : 24,
  currentTotalProgress: 1,
  animationPropsIn: "fadeIn .5s ease",
  animationPropsOut: "fadeOut .5s ease-in",
  reverseAnimationPropsIn: "fadeInBackwards .5s ease",
  reverseAnimationPropsOut: "fadeOutBackwards .5s ease",
  movingForward: true,
  globalUnmount: false,
  hideProgressForName: false,
  showNameGreeting: false,
  showBackBtn: false,
  quizMounted: false,
  postPartum: false,
  email_capture: false,
  quizAnswers: !!getSessionStorageObjectIfAvailable("quizAnswers")
    ? getSessionStorageObjectIfAvailable("quizAnswers")
    : {},
  isFinasteride: !!getSessionStorageIfAvailable("isFinasteride")
    ? getSessionStorageIfAvailable("isFinasteride") === "true"
    : "",
  isMinoxidil: !!getSessionStorageIfAvailable("isMinoxidil")
    ? getSessionStorageIfAvailable("isMinoxidil") === "true"
    : "",
  isNoHairHistory: !!getSessionStorageIfAvailable("isNoHairHistory")
    ? getSessionStorageIfAvailable("isNoHairHistory") === "true"
    : "",
  isMhmd: !!getSessionStorageIfAvailable("isMhmd")
    ? getSessionStorageIfAvailable("isMhmd") === "true"
    : "",
  mhmdState: !!getSessionStorageIfAvailable("mhmdState")
    ? getSessionStorageIfAvailable("mhmdState")
    : "",
  mhmdOpted: !!getSessionStorageIfAvailable("mhmdOpted")
    ? getSessionStorageIfAvailable("mhmdOpted") === "true"
    : true,
}

export const progressReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "INCREMENT_PROGRESS":
      return { ...state, quizProgress: action.payload }
    case "DECREMENT_PROGRESS":
      return { ...state, quizProgress: action.payload }
    case "INCREMENT_MIRROR_PROGRESS":
      return { ...state, progressBarProgress: action.payload }
    case "DECREMENT_MIRROR_PROGRESS":
      return { ...state, progressBarProgress: action.payload }
    case "SET_PROGRESS":
      return {
        ...state,
        quizProgress: action.payload,
        progressBarProgress: action.payload,
      }
    case "END_QUIZ_EARLY":
      return { ...state, endQuizEarly: true }
    case "UNEND_QUIZ_EARLY":
      return { ...state, endQuizEarly: false }
    case "INCREMENT_TOTAL_PROGRESS":
      // eslint-disable-next-line no-case-declarations
      const newProgress = state.currentTotalProgress + 1
      return { ...state, currentTotalProgress: newProgress }
    case "DECREMENT_TOTAL_PROGRESS":
      // eslint-disable-next-line no-case-declarations
      const newTotalProgress =
        state.currentTotalProgress > 1
          ? state.currentTotalProgress - 1
          : state.currentTotalProgress
      return { ...state, currentTotalProgress: newTotalProgress }
    case "SET_GLOBAL_PROGRESS":
      return { ...state, currentTotalProgress: action.payload }
    case "SET_TOTAL_QUESTIONS":
      return { ...state, totalQuestions: action.payload }
    case "SET_SHOW_BACK_BUTTON":
      return { ...state, showBackBtn: action.payload }
    case "SET_QUIZ_MOUNTED":
      return { ...state, quizMounted: action.payload }
    case "SET_EMAIL_CAPTURE":
      return { ...state, email_capture: action.payload }
    default:
      return state
  }
}

export const dynamicSectionLengthReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "DYNAMICALLY_SET_SECTION_LENGTH":
      return {
        ...state,
        [action.payload.section + "length"]: action.payload.length,
      }
    default:
      return state
  }
}

export const userReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_NAME":
      return { ...state, name: action.payload }
    case "SET_POST_PARTUM":
      return { ...state, postPartum: action.payload }
    default:
      return state
  }
}

export const sectionLengthReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_SECTION_LENGTH":
      return { ...state, sectionLength: action.payload }
    default:
      return state
  }
}

export const sectionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_CURRENT_SECTION":
      return { ...state, currentSection: action.payload }
    default:
      return state
  }
}

export const ageReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER_AGE":
      return { ...state, age: action.payload }
    default:
      return state
  }
}

export const interstitialReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "START_INTERSTITIAL":
      return { ...state, interstitial: true }
    case "END_INTERSTITIAL":
      return { ...state, interstitial: false }
    default:
      return state
  }
}

export const tokenReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_USER_TOKEN":
      return { ...state, token: action.payload }
    default:
      return state
  }
}

export const questionIdReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_QUESTION_ID":
      return { ...state, currentQuestionId: action.payload }
    default:
      return state
  }
}

export const responseCompleteReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_RESPONSE_COMPLETE":
      return { ...state, responseComplete: true }
    default:
      return state
  }
}

export const resultsResponseCompleteReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case "RES_COMPLETE":
      return { ...state, resultsResponseComplete: true }
    default:
      return state
  }
}

export const directionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TOGGLE_MOVING_FORWARD":
      return { ...state, movingForward: action.payload }
    default:
      return state
  }
}

export const globalUnmountReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "TRIGGER_GLOBAL_UNMOUNT":
      return { ...state, globalUnmount: action.payload }
    default:
      return state
  }
}

export const revealProgressReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "REVEAL_OR_HIDE_PROGRESS":
      return { ...state, hideProgressForName: action.payload }
    case "TOGGLE_NAME_GREETING":
      return { ...state, showNameGreeting: action.payload }
    default:
      return state
  }
}

export const productRecoReducer = (state = null, action) => {
  switch (action.type) {
    case "SET_PRODUCT_RECO":
      return action.payload
    default:
      return state
  }
}

export const updateQuizAnswersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "UPDATE_QUIZ_ANSWERS":
      return { ...state, quizAnswers: action.payload }
    default:
      return state
  }
}

export const setIsFinasterideMinoxidilReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case "SET_IS_FINASTERIDE":
      return { ...state, isFinasteride: action.payload }
    case "SET_IS_MINOXIDIL":
      return { ...state, isMinoxidil: action.payload }
    default:
      return state
  }
}

export const setIsNoHairHistoryReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_IS_NO_HAIR_HISTORY":
      return { ...state, isNoHairHistory: action.payload }
    default:
      return state
  }
}

export const setIsMhmdReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_IS_MHMD":
      return { ...state, isMhmd: action.payload }
    default:
      return state
  }
}

export const setMhmdStateReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_MHMD_STATE":
      return { ...state, mhmdState: action.payload }
    default:
      return state
  }
}

export const setMhmdOptedReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_MHMD_OPTED":
      return { ...state, mhmdOpted: action.payload }
    default:
      return state
  }
}

export const setHeaderVariantReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SET_HEADER_VARIANT":
      return { ...state, isIntroMode: action.payload }
    default:
      return state
  }
}

const locationDefaultState = {
  pathname: typeof window !== `undefined` ? window.location.pathname : "",
  search: typeof window !== `undefined` ? window.location.search : "",
  hash: typeof window !== `undefined` ? window.location.hash : "",
  href: typeof window !== `undefined` ? window.location.href : "",
}

export const locationReducer = (state = locationDefaultState, action) => {
  switch (action.type) {
    case "SET_LOCATION":
      return {
        pathname: action.payload.pathname || state.pathname,
        search: action.payload.search || state.search,
        hash: action.payload.hash || state.hash,
        href: action.payload.href || state.href,
      }
    default:
      return state
  }
}
